import env from '@maui-mf/env'
import { authenticatedFetch, store } from '@maui-mf/common-auth'

/**
 * Simple wrapper for authenticated fetch that sets the MA API host and
 * a convenience method for sending url searchParams
 */
export const maApiFetch = (pathname, { searchParams, ...fetchOptions } = {}, includeResJson = true) => {
  const url = new URL(pathname, env.MAAPI_HOST || env.default.MAAPI_HOST)

  if (searchParams) {
    Object.keys(searchParams).forEach(key => url.searchParams.append(key, searchParams[key]))
  }

  if (includeResJson) {
    return authenticatedFetch(url, fetchOptions).then(res => {
      if (res.status === 204) {
        return null
      }
      if (res.ok) {
        return res.json()
      } else {
        throw new Error(res.statusText)
      }
    })
  }
  return authenticatedFetch(url, fetchOptions)
}

export const validationApiFetch = (host, id) => {
  const pathname = `${host}/manage_sims/actions/filtered_actions.json?techniques=${encodeURIComponent(id)}`
  const token = store.getValue().token
  const options = {}
  options.headers = new Headers({})
  options.headers.set('Authorization', `Bearer ${token}`)
  return window.fetch(pathname, options).then(res => res.json())
}
